import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CopycatDirective } from './copycat.directive';

@NgModule({
  imports: [TranslateModule],
  declarations: [CopycatDirective],
  exports: [CopycatDirective],
  providers: [],
})
export class CopycatModule {}
